export default __webpack_public_path__ + "static/media/expressjs.7d023c32.svg";